





















































































































































import { Component, Vue } from 'vue-property-decorator'
import HeadLable from '@/components/HeadLable/index.vue'
import {
  getCategoryPage,
  deleCategory,
  editCategory,
  addCategory,
  enableOrDisableEmployee,
  upload
} from '@/api/category'
import Empty from '@/components/Empty/index.vue'
import ImageUpload from '@/components/ImgUpload/index.vue'
import { getToken } from '@/utils/cookies'

interface CategoryRow {
  id: number;
  name: string;
  image?: string;
  sort: number;
  status: string | number;
  updateTime?: string;
}

@Component({
  name: 'Category',
  components: {
    HeadLable,
    Empty,
    ImageUpload
  }
})
export default class extends Vue {

  private actionType: string = ''
  private id = ''
  private status = ''

  private name: string = ''
  private action: string = ''
  private counts: number = 0
  private page: number = 1
  private pageSize: number = 10
  private tableData: CategoryRow[] = []
  private type = ''
  private isSearch: boolean = false
  private classData: any = {
    title: '添加商品分类',
    dialogVisible: false,
    categoryId: '',
    name: '',
    sort: '',
    image: ''
  }

  private uploadHeaders = {
    token: getToken()
  }

  get rules() {
    return {
      name: [
        {
          required: true,
          trigger: 'blur',
          validator: (rule: any, value: string, callback: Function) => {
            // 允许数字、字母、中文和其他语言字符
            // 只排除特殊符号如 !@#$%^&*()等
            var reg = /^[^\!\@\#\$\%\^\&\*\(\)\_\+\-\=\[\]\{\}\;\:\"\'\<\>\,\.\?\/\\\|\`\~]+$/
            if (!value) {
              callback(new Error(this.classData.title + '不能为空'))
            } else if (value.length < 2) {
              callback(new Error('分类名称输入不符，请输入2-20个字符'))
            } else if (!reg.test(value)) {
              callback(new Error('分类名称不能包含特殊符号'))
            } else {
              callback()
            }
          }
        }
      ],
      sort: [
        {
          required: true,
          trigger: 'blur',
          validator: (rule: any, value: string, callback: Function) => {
            if (value || String(value) === '0') {
              const reg = /^\d+$/
              if (!reg.test(value)) {
                callback(new Error('排序只能输入数字类型'))
              } else if (Number(value) > 99) {
                callback(new Error('排序只能输入0-99数字'))
              } else {
                callback()
              }
            } else {
              callback(new Error('排序不能为空'))
            }
          }
        }
      ]
    }
  }

  created() {
    this.init()
  }

  // 初始化信息
  private async init(isSearch?: boolean) {
    this.isSearch = isSearch || false;
    console.log('开始加载分类数据');
    
    try {
      const res = await getCategoryPage({
        page: this.page,
        pageSize: this.pageSize,
        name: this.name ? this.name : undefined
      });
      
      console.log('分类接口返回:', res);
      
      if (String(res.data.code) === '1') {
        this.tableData = res.data.data && res.data.data.records ? res.data.data.records : [];
        this.counts = Number(res.data.data.total);
        console.log('分类数据:', this.tableData);
      } else {
        this.$message.error(res.data.desc || '获取分类数据失败');
      }
    } catch (err) {
      console.error('获取分类数据错误:', err);
      this.$message.error('请求出错了：' + (err.message || '未知错误'));
    }
  }

  // 添加
  private addClass(st: any) {
    this.classData.title = '新增商品分类'
    this.type = '1'
    this.action = 'add'
    this.classData.name = ''
    this.classData.sort = ''
    this.classData.image = ''
    this.classData.dialogVisible = true
    this.actionType = 'add'
  }

  // 修改
  private editHandle(dat: CategoryRow) {
    console.log('修改分类:', dat);
    this.classData.title = '修改分类'
    this.action = 'edit'
    this.classData.name = dat.name
    this.classData.sort = dat.sort
    this.classData.image = dat.image || ''
    this.classData.id = dat.id
    this.classData.dialogVisible = true
    this.actionType = 'edit'
  }

  // 关闭弹窗
  private handleClose(st: string) {
    this.classData.dialogVisible = false
    //对该表单项进行重置，将其值重置为初始值并移除校验结果
    this.$refs.classData.resetFields()
  }

  //状态修改
  private statusHandle(row: CategoryRow) {
    this.id = String(row.id);
    this.status = String(row.status);
    this.$confirm('确认调整该分类的状态?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      customClass: 'customClass'
    }).then(() => {
      // 如果当前状态是1（启用），则切换为0（禁用）；如果是0（禁用），则切换为1（启用）
      const newStatus = this.status === '1' ? 0 : 1;
      
      enableOrDisableEmployee({ id: this.id, status: newStatus })
        .then(res => {
          if (String(res.status) === '200') {
            this.$message.success('分类状态更改成功！')
            this.init()
          }
        })
        .catch(err => {
          this.$message.error('请求出错了：' + err.message)
        })
    })
  }

  //删除
  private deleteHandle(id: number) {
    this.$confirm('此操作将永久删除该分类，是否继续？', '确定删除', {
      confirmButtonText: '删除',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      deleCategory(String(id))
        .then(res => {
          if (res.data.code === 1) {
            this.$message.success('删除成功！')
            this.init()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          this.$message.error('请求出错了：' + err.message)
        })
    })
  }

  $refs!: {
    classData: any
  }

  //数据提交
  submitForm(st: string = '') {
    if (this.action === 'add') {
      this.$refs.classData.validate((value: boolean) => {
        if (value) {
          console.log('提交新增数据:', {
            name: this.classData.name,
            type: this.type,
            sort: this.classData.sort,
            image: this.classData.image
          });
          
          addCategory({
            name: this.classData.name,
            type: this.type,
            sort: this.classData.sort,
            image: this.classData.image
          })
            .then(res => {
              if (res.data.code === 1) {
                this.$message.success('分类添加成功！')
                this.$refs.classData.resetFields()
                if (!st) {
                  this.classData.dialogVisible = false
                }
                this.init()
              } else {
                this.$message.error(res.data.desc || res.data.msg)
              }
            })
            .catch(err => {
              this.$message.error('请求出错了：' + err.message)
            })
        }
      })
    } else {
      this.$refs.classData.validate((value: boolean) => {
        if (value) {
          console.log('提交修改数据:', {
            id: this.classData.id,
            name: this.classData.name,
            sort: this.classData.sort,
            image: this.classData.image
          });
          
          editCategory({
            id: this.classData.id,
            name: this.classData.name,
            sort: this.classData.sort,
            image: this.classData.image
          })
            .then(res => {
              if (res.data.code === 1) {
                this.$message.success('分类修改成功！')
                this.classData.dialogVisible = false
                this.$refs.classData.resetFields()
                this.init()
              } else {
                this.$message.error(res.data.desc || res.data.msg)
              }
            })
            .catch(err => {
              this.$message.error('请求出错了：' + err.message)
            })
        }
      })
    }
  }

  //分页
  private handleSizeChange(val: any) {
    this.pageSize = val
    this.init()
  }

  private handleCurrentChange(val: any) {
    this.page = val
    this.init()
  }

  private imageChange(imageUrl: string) {
    this.classData.image = imageUrl;
  }
}
